import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

const breadcrumbs = [
    {
        to: {
            name: routeType.TODO_LIST,
        },
        label: 'menu.todos',
        roles: [ROLE_ADMIN],
    },
]

const passthroughRender = {
    render: (c) => c('router-view'),
}

export default [
    {
        path: '/todos',
        component: passthroughRender,
        meta,
        children: [
            {
                path: '',
                name: routeType.TODO_LIST,
                component: () =>
                    import(
                        /* webpackChunkName: "todo-list" */ '@/pages/todo/List.vue'
                    ),
                meta,
            },
            {
                path: 'create',
                name: routeType.TODO_CREATE,
                component: () =>
                    import(
                        /* webpackChunkName: "todo-edit" */ '@/pages/todo/Create.vue'
                    ),
                meta: {
                    ...meta,
                    breadcrumbs,
                },
            },
            {
                path: ':id',
                name: routeType.TODO_EDIT,
                component: () =>
                    import(
                        /* webpackChunkName: "todo-edit" */ '@/pages/todo/Edit.vue'
                    ),
                meta: {
                    ...meta,
                    breadcrumbs,
                },
            },
        ],
    },
]
